import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import * as flags from 'country-flag-icons/react/3x2';
import { COUNTRIES, CountryOption } from '../../../services/countries.service';
import { isPremiumRateCountry } from '../../../config/premiumRateCountries';

interface CountrySelectorProps {
  value?: string;
  onChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
}

export const CountrySelector: React.FC<CountrySelectorProps> = ({
  value,
  onChange,
  placeholder = 'Select country',
  disabled = false,
  className = '',
}) => {
  // Helper to get flag component for a country code
  const getFlagComponent = (code: string) => {
    const FlagComponent = (flags as any)[code];
    return FlagComponent;
  };

  // Find selected country data ('USA' is a legacy saved value for United States)
  const selectedCountry: CountryOption | undefined =
    COUNTRIES.find(c => c.name === value) ||
    (value === 'USA' ? { name: 'USA', code: 'US' } : undefined);

  return (
    <Select value={value} onValueChange={onChange} disabled={disabled}>
      <SelectTrigger className={`h-7 text-sm font-mono ${className}`}>
        <SelectValue placeholder={placeholder}>
          {selectedCountry && (
            <div className="flex items-center gap-2">
              {(() => {
                const Flag = getFlagComponent(selectedCountry.code);
                return Flag ? <Flag className="h-4 w-6" /> : null;
              })()}
              <span>{selectedCountry.name}</span>
              {isPremiumRateCountry(selectedCountry.name) && (
                <span className="text-xs text-muted-foreground">*</span>
              )}
            </div>
          )}
        </SelectValue>
      </SelectTrigger>
      <SelectContent>
        <div className="text-xs text-muted-foreground px-2 py-1.5 font-semibold">
          * = Premium rate country (1.25x)
        </div>
        {COUNTRIES.map((country) => {
          const Flag = getFlagComponent(country.code);
          return (
            <SelectItem key={country.name} value={country.name}>
              <div className="flex items-center gap-2">
                {Flag && <Flag className="h-4 w-6" />}
                <span>{country.name}</span>
                {isPremiumRateCountry(country.name) && (
                  <span className="text-xs text-muted-foreground ml-1">*</span>
                )}
              </div>
            </SelectItem>
          );
        })}
      </SelectContent>
    </Select>
  );
};
